export default function getDictionaryTranslation(dictionary, clang, key, type) {
    const dictForType = dictionary[type];

    if (!dictForType) {
        return key;
    }
    const dictForTypeClang = dictForType.filter(dict => dict.lang === clang)[0];

    if (!dictForTypeClang) {
      return key;
    }

    const dictForTypeEntries = dictForTypeClang.entries;
    const dictForTypeEntry = dictForTypeEntries.filter(entry => entry.id === key)[0];

    if (dictForTypeEntry) {
        return dictForTypeEntry.label;
    } else {
        return key;
    }
};



// WEBPACK FOOTER //
// ./src/scripts/GetDictionaryTranslation.js